<section fxLayoutAlign="space-between start" class="header">
  <div class="header-sidenav">
    <img src="./assets/logo2.png" alt="Viseu-logo" height="64" />
    <!-- <img *ngIf="userLogged" [src]="userLogo" alt="Viseu-logo" height="64" /> -->
  </div>
  <p class="titulo-header">
    Sistema de Atendimentos
  </p>
</section>
